import { useMutation } from "@tanstack/react-query";
import { initiateBatch } from "api/invoice.api";

export const useCreateBatch = () => {
  return useMutation({
    mutationFn: (data) => initiateBatch(data),
    onSuccess: (response) => {
      console.log(response);
    },
    onError: (error) => {
      console.log("error creating batch : ", error);
    },
  });
};
